module.exports = __webpack_public_path__ + "img/14.b7060190.jpg";